import React, { useState, useEffect } from "react";
import { Input } from "antd";
import { setSelectedInfluencerUsernameContains } from "../../redux/store/genericReportingSlice";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "@uidotdev/usehooks";

const UsernameSearchInput = () => {
  const dispatch = useDispatch();

  const selectedUsername = useSelector(
    (state) => state.genericReporting.selectedInfluencerUsernameContains
  );

  const [inputValue, setInputValue] = useState(selectedUsername);

  // Debounce the inputValue
  const debouncedValue = useDebounce(inputValue, 150); // 300ms debounce delay

  // Dispatch only when debouncedValue changes
  useEffect(() => {
    dispatch(setSelectedInfluencerUsernameContains(debouncedValue));
  }, [debouncedValue, dispatch]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div style={{ marginLeft: "0.5vw", marginRight: "0.5vw" }}>
      <h4>Username</h4>
    <Input
      type="text"
      value={inputValue}
      onChange={handleInputChange}
      placeholder="Username"
      style={{
        width: "10vw",
      }}
    />
    </div>

  );
};

export default UsernameSearchInput;
